import { useQuery } from '@tanstack/react-query';
import { getConversationHistoryByContactAndChannel } from '../services/chatService';

/**
 * Todas as conversas FECHADAS de um contato em um canal, paginadas por recência.
 * Usada pela HistoryConversationView (metadados: contagem, provider e datas
 * por conversationId para os divisores de atendimento).
 */
export const useConversationHistoryDetail = (
  contactId: string | undefined,
  channelId: string | undefined,
  query?: { page?: number; limit?: number }
) => {
  return useQuery({
    queryKey: ['conversations', 'history-detail', contactId, channelId, query?.page ?? 1, query?.limit ?? 20],
    queryFn: async ({ signal }) => {
      return getConversationHistoryByContactAndChannel(contactId as string, channelId as string, query, signal);
    },
    enabled: !!contactId && !!channelId,
    staleTime: 30 * 1000,
  });
};
